import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {DesignConceptsLogicService, IDesignConceptMappedItem} from '@app/logic/design-concepts';
import {CbDialogService} from '@app/shared/components/dialog/cb-dialog.service';
import {
    IDesignConceptDto,
    IUploadImageDto,
    LOT_IMAGE_TYPE_ENUM,
    LotImageTypeEnumId
} from '@classictechsolutions/hubapi-transpiled-enums';
import {MultiImageUploadDialogComponent} from "@app/shared/components/image-handlers/multi-image-upload-dialog/multi-image-upload-dialog.component";

@Component({
    selector: 'cb-design-concept-info',
    templateUrl: './design-concept-info.component.html',
    styleUrls: ['./design-concept-info.component.scss'],
    standalone: false
})
export class DesignConceptInfoComponent {

    @Input() public designConcept: IDesignConceptMappedItem;
    protected readonly LotImageTypeEnumId = LotImageTypeEnumId;

    public selectedIndex = 0;
    public isCollapsed = false;

    constructor(
        private readonly cbDialog: CbDialogService,
        private readonly designConceptsLogicService: DesignConceptsLogicService,
        private readonly cdr: ChangeDetectorRef
    ) { }

    public get isExteriorSelected(): boolean {
        return this.selectedIndex === 0;
    }

    public get isFloorPlanSelected(): boolean {
        return this.selectedIndex === 1;
    }


    public get imageType(): string {
        if (this.isExteriorSelected) {
            return LOT_IMAGE_TYPE_ENUM[LOT_IMAGE_TYPE_ENUM.Exterior];
        } else if (this.isFloorPlanSelected) {
            return LOT_IMAGE_TYPE_ENUM[LOT_IMAGE_TYPE_ENUM.FloorPlan];
        }
    }

    public filterByTypeUrls(
        images: IUploadImageDto[],
        type: LotImageTypeEnumId
    ): string[] {
        if (!images?.length) return [];

        return images
            .filter(i => i?.imageType === type)
            .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            .map(i => i.url);
    }

    public getUploadButtonText(): string {
        let imageUploaded;
        if (this.isExteriorSelected) {
            imageUploaded = this.designConcept.exteriorImageUrl !== undefined;
        } else if (this.isFloorPlanSelected) {
            imageUploaded = this.designConcept.floorPlanImageUrl !== undefined;
        }
        return imageUploaded ? `Manage ${this.imageType} Images` : `Setup First ${this.imageType} Image`;
    }

    public getImageType(): number {
        // LotImageTypeEnumId
        return this.selectedIndex + 1;
    }

    public uploadImage(): void {

        const dialogRef = this.cbDialog.open(MultiImageUploadDialogComponent, {
            data: {
                dialogHeading: 'Upload & Reorder Images',
                entityId: this.designConcept.id,
                lotId: this.designConcept.lotId,
                imageType: this.getImageType(),
                existingImages: this.designConcept.images.filter(x=>x.imageType === this.getImageType()),
                logicService: this.designConceptsLogicService,
                maxAllowed: this.isExteriorSelected ? 15 : 1
            }
        });

        dialogRef.componentInstance.imagesUpdated.subscribe((updatedDto: IDesignConceptDto) => {
            // Forced to set it to undefined when all images are deleted; otherwise, $updateThisAndOriginal retains the last image
            this.designConcept.exteriorImageUrl = updatedDto.exteriorImageUrl;
            this.designConcept.floorPlanImageUrl = updatedDto.floorPlanImageId;
            this.designConcept.$updateThisAndOriginal(updatedDto);
            this.cdr.markForCheck();
        });
    }
}
